// extracted by mini-css-extract-plugin
export default {"floating":"UrgencySignalsNode-module__floating___3cVlV","urgencyMessages":"UrgencySignalsNode-module__urgencyMessages___2UnrC"};